import { ConfigService } from "../services/config/configs.service";
import { store } from "../store/store";

export const SET_CONFIGS = 'SET_CONFIGS';

export const fetchConfigs = async () => {
    const res = await ConfigService.getList();
    store.dispatch(setConfigs(res));
}

export const setConfigs = (data: any) => {
    return {
        type: SET_CONFIGS,
        data
    }
}
